import type {
  PriceComparisonPrice,
  PurchaseRequestApprovalState,
} from "@/types";

interface FindSelectedPriceOptions {
  requireArsPrice?: boolean;
}

/**
 * Shared selector for the chosen supplier price inside a comparison row.
 */
export function findSelectedPrice(
  prices: (PriceComparisonPrice | null)[] | undefined,
  options: FindSelectedPriceOptions = {},
): PriceComparisonPrice | null {
  if (!prices?.length) return null;

  const { requireArsPrice = false } = options;

  for (const price of prices) {
    if (!price?.is_selected) continue;
    if (requireArsPrice && price.unit_price_ars == null) continue;
    return price;
  }

  return null;
}

/**
 * Shared resolver for approval total from selections payload.
 */
export function resolveSelectionsTotalArs(
  approval: Pick<
    PurchaseRequestApprovalState,
    "selections_totals"
  >,
): number {
  return approval.selections_totals?.total_ars ?? 0;
}
